export const defaultValidationMessages = {
  required: 'input-text.required',
  weak: 'input-text.weak-password',
  minlength: 'input-text.min-length',
  maxlength: 'input-text.max-length',
  invalidEmail: 'validation.invalid-email',
  invalidPasswordPattern: 'input-text.weak-password',
  postalCodeFormatInvalidPt: 'address.zipcode-format-error-pt'
};
